import { styled } from "@mui/material/styles";
import get from "lodash/get";
import BSInput from "../../../common/js/components/BSInput";
import FormTitle from "../../../common/js/components/FormTitle";

const StyledResizeComment = styled(BSInput)(({ theme }) => ({
    "& textarea": {
        resize: "vertical",
    },
}));

const PropertyCommentBlock = (props) => {
    const { disableInputs, errors, handleInputChange, property, prefix, showFormTitle } = props;
    return (
        <>
            {showFormTitle && <FormTitle title="Property Comments" />}
            <StyledResizeComment
                id="memberComments"
                label="Internal Comments"
                placeholder="Comments entered here are only visible inside KMConnect."
                error={errors.memberComments}
                value={get(property, "memberComments", null)}
                multiline
                rows={5}
                onChange={(e) => handleInputChange(prefix + e.target.id, e.target.value)}
                disabled={disableInputs}
            />
            <StyledResizeComment
                id="publicComments"
                label="Public Comments"
                placeholder="Comments entered here PUBLIC and will be VISIBLE on reports and excel exports."
                error={errors.publicComments}
                value={get(property, "publicComments", null)}
                multiline
                rows={5}
                onChange={(e) => handleInputChange(prefix + e.target.id, e.target.value)}
                disabled={disableInputs}
            />
        </>
    );
};

export default PropertyCommentBlock;
